import React, { useState } from "react";

function SubsequentActions({ items }: any) {
  const [isVisible, setIsVisible] = useState(false);

  function toggleContainer() {
    setIsVisible(!isVisible);
  }

  return items && items.length ? (
    <div className="subsequent-actions-wrapper">
      <a
        className="hawk-actions-link"
        aria-label="Expand Subsequent Actions"
        onClick={toggleContainer}
      >
        Subsequent actions
      </a>
      <div
        className={`subsequent-actions${
          isVisible ? " subsequent-actions__visible" : ""
        }`}
      >
        {items.map((item) => (
          <a className="" target="_blank" href={item.mediaUrl}>
            {item.title}
          </a>
        ))}
      </div>
    </div>
  ) : null;
}

export default SubsequentActions;
